import { GraduationCap, Users, Building2, Landmark } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";

const phases = [
  {
    icon: GraduationCap,
    phase: "Phase 01",
    title: "Academy",
    body: "Education, structure and mentorship. Where every disciplined trader begins.",
    status: "Live now",
    vision: false,
  },
  {
    icon: Users,
    phase: "Phase 02",
    title: "Performance Team",
    body: "Our strongest graduates train and trade together under one shared standard.",
    status: "Vision",
    vision: true,
  },
  {
    icon: Building2,
    phase: "Phase 03",
    title: "Trading Headquarters",
    body: "A physical home in Melbourne, a dedicated performance floor for the team.",
    status: "Vision",
    vision: true,
  },
  {
    icon: Landmark,
    phase: "Phase 04",
    title: "MBM Capital",
    body: "Backing our elite traders with real capital, the ultimate destination.",
    status: "Vision",
    vision: true,
  },
];

export default function FutureVision() {
  return (
    <section
      id="vision"
      className="relative py-24 sm:py-32 lg:py-40 border-t border-white/5"
      data-testid="vision-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <SectionLabel>Future Vision</SectionLabel>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight max-w-2xl">
            A roadmap beyond the classroom.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-4 text-sm text-zinc-500 font-light max-w-xl">
            The Academy is here today. The stages that follow are the long term
            vision of MBM, where we are building toward, not current offerings.
          </p>
        </Reveal>

        <div className="mt-16 relative">
          <div className="hidden lg:block absolute top-9 left-0 right-0 h-px bg-gradient-to-r from-[#6ea8ff]/60 via-white/15 to-white/5" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {phases.map((p, i) => {
              const Icon = p.icon;
              return (
                <Reveal key={p.title} delay={i * 0.12}>
                  <div className="relative" data-testid={`vision-phase-${i}`}>
                    <div
                      className="h-[72px] w-[72px] rounded-full flex items-center justify-center border bg-[#0A0A0A]"
                      style={{ borderColor: p.vision ? "rgba(255,255,255,0.15)" : "#6ea8ff" }}
                    >
                      <Icon
                        strokeWidth={1}
                        className="h-7 w-7"
                        style={{ color: p.vision ? "#a1a1aa" : "#9fd3ff" }}
                      />
                    </div>
                    <div className="mt-6 flex items-center gap-2">
                      <span className="section-label text-[9px] text-zinc-600">{p.phase}</span>
                      <span
                        className="section-label text-[9px] px-2 py-0.5 border"
                        style={{
                          color: p.vision ? "#71717a" : "#7ee0a1",
                          borderColor: p.vision ? "rgba(255,255,255,0.12)" : "rgba(126,224,161,0.4)",
                        }}
                      >
                        {p.status}
                      </span>
                    </div>
                    <h3 className="mt-3 font-heading text-2xl font-light" style={{ color: p.vision ? "#d4d4d8" : "#FAFAFA" }}>
                      {p.title}
                    </h3>
                    <p className="mt-3 text-sm text-zinc-400 font-light leading-relaxed">{p.body}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
